<template>
    <b-container>
        <div class="card ">
            <div class="card-header main-card">
                Manuales de uso de la aplicación
            </div>
            <div class="card-body d-flex flex-row">
                <div class="p-4">
                    <div class="my-3">
                        <span class="mr-4">
                            Manual de usuario
                        </span>
                        <a :href="userManual" target="_blank" class="border py-2 px-4 btn btn-light">
                            <i class="fa fa-download mr-3"></i>
                            <span>Descargar</span>
                        </a>
                    </div>
                    <div class="my-3">
                        <span class="mr-4">
                            Manual de administración
                        </span>
                        <a :href="adminManual" target="_blank" class="border py-2 px-4 btn btn-light">
                            <i class="fa fa-download mr-3"></i>
                            <span>Descargar</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </b-container>
</template>

<script>
export default {
    data() {
        return {
            userManual: require('../../../assets/user-manual.pdf'),
            adminManual: require('../../../assets/admin-manual.pdf')
        }
    }
}
</script>